/* eslint-disable */

function toXCodeArray(str: string) {
  const x = [];
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    if (c < 0x80) x.push(c);
    else if (c < 0x800) {
      x.push(0xc0 | (c >> 6), 0x80 | (c & 0x3f));
    } else if (c < 0xd800 || c >= 0xe000) {
      x.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 0x3f), 0x80 | (c & 0x3f));
    } else {
      i++;
      c = 0x10000 + (((c & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
      x.push(0xf0 | (c >> 18), 0x80 | ((c >> 12) & 0x3f), 0x80 | ((c >> 6) & 0x3f), 0x80 | (c & 0x3f));
    }
  }
  return x;
}

function xEncode(d: any, k: any) {
  const data = JSON.stringify(d)
  const key = `${k}`;

  let r = '';
  let t: any = '';
  let o = '';
  let i = 0;
  let m = 0;
  const mm = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  let c1; let c2; let c3; let e1; let e2; let e3; let e4;
  const dArray = toXCodeArray(data);
  let j;
  for (i = dArray.length - 1, j = 0; i >= 0; i--) {
    t = dArray[i] ^ key.charCodeAt(j) ^ m;
    r = r + String.fromCharCode(t);
    j = (++j) % key.length;
    m = t;
  }
  i = 0;
  while (i < r.length) {
    c1 = r.charCodeAt(i++);
    c2 = r.charCodeAt(i++);
    c3 = r.charCodeAt(i++);
    e1 = c1 >> 2;
    e2 = ((c1 & 3) << 4) | (c2 >> 4);
    e3 = ((c2 & 15) << 2) | (c3 >> 6);
    e4 = c3 & 63;
    if (isNaN(c2)) {
      e3 = e4 = 64;
    } else if (isNaN(c3)) {
      e4 = 64;
    }
    o = o + mm.charAt(e1) + mm.charAt(e2) + mm.charAt(e3) + mm.charAt(e4);
  }
  return o;
}


function post(url: any, data: any) {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'text/plain');
    xhr.send(data || {});
  } catch (err) {
    // console.warn('log report fail: ', err);
  }
}

function generateGuid() {
  const s: any = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; ++i) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';
  return s.join('');
}

export default {
  xEncode,
  post,
  generateGuid,
}